import React from 'react';
import CircularProgress from "@material-ui/core/CircularProgress";
import Table from "../../../../../../../util/Table/.mixins/Table";
import Alerta from "../../../../../../../util/snackbars/.mixins/";

//css
import EtiquetasCss from './EtiquetasLista-css';
const useStyles = EtiquetasCss();

export default function EtiquetasLista(props) {
    const classes = useStyles();
    return (
        <div className="container">

            {props.state.isLoading &&
            <div align="center">
                <CircularProgress />
            </div>
            }
            {!props.state.isLoading &&
            <div>
                <Table {...props} className={classes.root}/>
                <Alerta ref={props.child}/>
            </div>
            }

        </div>
    );
}